import React from 'react';
import { Input, Space, Typography } from 'antd';

import { useEditorDoc, useEditorDispatch, useEditorMeta } from '../../EditorProvider';
import type { RebusDoc } from './doc';
import type { RebusAction } from './reducer';
import { ImageUploader } from './ImageUploader';

// O formulário do rébus: título, dica, solução e o upload. Não há lista de palavras
// nem seleção — o rébus é um jogo de um campo só.
//
// ⚠️ O campo do meio é a coluna `numeracao`, mas o RÓTULO é "Dica": o que ela guarda
// é o texto que o jogador lê acima da imagem (games/Rebus/index.tsx renderiza
// `<span>{rebus.numeracao}</span>`). Rotular "Numeração" faz o admin preencher um
// número — o erro que o protótipo comete hoje ao gravar '1' fixo.

export const Inspector: React.FC = () => {
  const doc = useEditorDoc<RebusDoc>();
  const { do: dispatchAction } = useEditorDispatch();
  const { editavel } = useEditorMeta();
  const dispatch = (action: RebusAction) => dispatchAction(action);

  return (
    <div style={{ minWidth: 300, maxWidth: 380 }}>
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Input
          addonBefore="Título"
          aria-label="Título"
          value={doc.titulo}
          disabled={!editavel}
          onChange={(e) => dispatch({ type: 'SET_TITULO', titulo: e.target.value })}
        />

        <div>
          <Typography.Text strong>Dica</Typography.Text>
          <Input.TextArea
            aria-label="Dica"
            rows={2}
            placeholder="Texto mostrado ao jogador acima da imagem"
            value={doc.numeracao}
            disabled={!editavel}
            onChange={(e) => dispatch({ type: 'SET_NUMERACAO', numeracao: e.target.value })}
          />
          <Typography.Text type="secondary">
            Opcional: sem ela o jogador vê só a imagem.
          </Typography.Text>
        </div>

        <div>
          <Typography.Text strong>Solução</Typography.Text>
          <Input
            aria-label="Solução"
            placeholder="A resposta que o jogador digita"
            status={doc.solucao.trim() === '' ? 'error' : undefined}
            aria-invalid={doc.solucao.trim() === ''}
            value={doc.solucao}
            disabled={!editavel}
            onChange={(e) => dispatch({ type: 'SET_SOLUCAO', solucao: e.target.value })}
          />
          <Typography.Text type="secondary">
            Obrigatória. É gravada em MAIÚSCULAS — é assim que o jogo compara a resposta. Espaços
            separam as palavras que a dica revela uma a uma.
          </Typography.Text>
        </div>

        <div>
          <Typography.Text strong>Imagem</Typography.Text>
          <div style={{ marginTop: 8 }}>
            <ImageUploader block />
          </div>
        </div>
      </Space>
    </div>
  );
};
